import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as modalActions from '@/store/modal/actions'
import * as userActions from '@/store/user/actions'
import {
	hasActiveSubscriptionSelector,
	hasManagementRefSelector,
	hasPortalAccessSelector,
	userCompaniesSelector,
	userIsFetchingSelector,
} from '@/store/user/selectors'
import SBModal from '@/components/sb-modal'
import PaywallModal from '@/components/paywall-modal'

const PaywallContainer = ({
	clients,
	hasActiveSubscription,
	hasPortalAccess,
	hasManagementRef,
	isFetchingUser,
	modalShow,
	userRequest,
}) => {
	const onChargebeeError = () => {
		modalShow({
			title: 'Something went wrong',
			message: 'Please check your connection or try again later.',
		})
	}

	const salesEmail = (
		<a href="mailto:smartbuildings@ecobee.com">smartbuildings@ecobee.com</a>
	)
	let title
	let message

	switch (true) {
		case hasPortalAccess === false && hasActiveSubscription === true:
			title =
				'Your SmartBuildings subscription does not include access to the web portal'
			message = (
				<span>
					Please contact ecobee’s SmartBuildings team at{' '}
					<span>{salesEmail}</span> if you would like to upgrade.
				</span>
			)
			break
		case hasPortalAccess === false && hasActiveSubscription === false:
			title = 'Your SmartBuildings account has been cancelled'
			message = (
				<span>
					Please contact ecobee’s SmartBuildings team at{' '}
					<span>{salesEmail}</span> if you would like to reactivate.
				</span>
			)
			break
		default:
			title = 'Your SmartBuildings account has been cancelled'
			message = 'Reactivate it by purchasing a subscription.'
	}

	return (
		<SBModal
			className="cmp__paywall-modal"
			label={title}
			isOpen={
				(hasActiveSubscription === false && hasManagementRef === false) ||
				hasPortalAccess === false
			}
		>
			<PaywallModal
				hasMultipleClients={clients.length > 1}
				isFetchingUser={isFetchingUser}
				onChargebeeError={onChargebeeError}
				refetchUser={userRequest}
				title={title}
				message={message}
				showReactivateCta={hasPortalAccess}
			/>
		</SBModal>
	)
}

PaywallContainer.propTypes = {
	clients: PropTypes.arrayOf(PropTypes.any).isRequired,
	hasActiveSubscription: PropTypes.bool,
	hasPortalAccess: PropTypes.bool,
	hasManagementRef: PropTypes.bool.isRequired,
	isFetchingUser: PropTypes.bool.isRequired,
	modalShow: PropTypes.func.isRequired,
	userRequest: PropTypes.func.isRequired,
}

const mapStateToProps = /* istanbul ignore next */ (state) => ({
	hasActiveSubscription: hasActiveSubscriptionSelector(state),
	hasPortalAccess: hasPortalAccessSelector(state),
	hasManagementRef: hasManagementRefSelector(state),
	clients: userCompaniesSelector(state),
	isFetchingUser: userIsFetchingSelector(state),
})

const mapDispatchToProps = /* istanbul ignore next */ (dispatch) => ({
	modalShow: (payload) => {
		dispatch(modalActions.modalShow(payload))
	},
	userRequest: () => {
		dispatch(userActions.getUserRequest())
	},
})

export { PaywallContainer as PaywallContainerComponent }

export default connect(mapStateToProps, mapDispatchToProps)(PaywallContainer)
